"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpressResponseCodes = exports.Language = exports.WorldpayResponseStatuses = void 0;
var WorldpayResponseStatuses;
(function (WorldpayResponseStatuses) {
    WorldpayResponseStatuses[WorldpayResponseStatuses["RESPONSE_READY"] = 200] = "RESPONSE_READY";
    WorldpayResponseStatuses[WorldpayResponseStatuses["RESPONSE_NOT_READY"] = 202] = "RESPONSE_NOT_READY";
})(WorldpayResponseStatuses || (exports.WorldpayResponseStatuses = WorldpayResponseStatuses = {}));
var Language;
(function (Language) {
    Language["ENGLISH"] = "English";
    Language["FRENCH"] = "French";
})(Language || (exports.Language = Language = {}));
/**
 * Reference: https://developerengine.fisglobal.com/apis/express/express-xml/responses
 */
var ExpressResponseCodes;
(function (ExpressResponseCodes) {
    ExpressResponseCodes["APPROVED"] = "0";
    ExpressResponseCodes["PARTIAL_APPROVAL"] = "5";
    ExpressResponseCodes["DCC_REQUESTED"] = "7";
    ExpressResponseCodes["NON_FINANCIAL_CARD"] = "8";
    ExpressResponseCodes["DECLINED"] = "20";
    ExpressResponseCodes["EXPIRED_CARD"] = "21";
    ExpressResponseCodes["DUPLICATE_APPROVED"] = "22";
    ExpressResponseCodes["DUPLICATE"] = "23";
    ExpressResponseCodes["PICK_UP_CARD"] = "24";
    ExpressResponseCodes["REFERRAL_CALL_ISSUER"] = "25";
    ExpressResponseCodes["BALANCE_NOT_AVAILABLE"] = "30";
    ExpressResponseCodes["NOT_DEFINED"] = "90";
    ExpressResponseCodes["INVALID_DATA"] = "101";
    ExpressResponseCodes["INVALID_ACCOUNT"] = "102";
    ExpressResponseCodes["INVALID_REQUEST"] = "103";
    ExpressResponseCodes["AUTHORIZATION_FAILED"] = "104";
    ExpressResponseCodes["NOT_AUTHORIZED"] = "105";
    ExpressResponseCodes["OUT_OF_BALANCE"] = "120";
    ExpressResponseCodes["COMMUNICATION_ERROR"] = "1001";
    ExpressResponseCodes["HOST_ERROR"] = "1002";
    ExpressResponseCodes["ERROR"] = "1009";
})(ExpressResponseCodes || (exports.ExpressResponseCodes = ExpressResponseCodes = {}));
//# sourceMappingURL=enums.js.map